import React, {FC} from "react"
import {Grid, Row, Col} from "react-bootstrap"

import {FormattedMessage, InjectIntl, injectIntl} from "@irati/utils/lang"
import id from "@irati/utils/id"
import {PerkboxLogo} from "@irati/ui/src/Logos"

import Version from "../Version"
import {StyledRow, FooterWrapper, Copyright, List} from "./styled"

interface Props extends InjectIntl {}

const Footer: FC<Props> = (props) => {
  const idNamespace = id("footer", {}, {force: true})
  const {formatMessage} = props
  return (
    <>
      <FooterWrapper id={idNamespace}>
        <Grid id={id("container", idNamespace)}>
          <StyledRow>
            <Col md={12}>
              <PerkboxLogo />
            </Col>
          </StyledRow>
          <Row>
            <Col md={12}>
              <List>
                <li>
                  <a
                    id={id("link-about", idNamespace)}
                    href={formatMessage({id: "platform.footer.href.about.href"})}
                    target="_blank"
                    rel="noopener noreferrer">
                    <FormattedMessage id="platform.footer.href.about.text" />
                  </a>
                </li>
                <li>
                  <a
                    id={id("link-help", idNamespace)}
                    href={formatMessage({id: "platform.footer.href.help.href"})}
                    target="_blank"
                    rel="noopener noreferrer">
                    <FormattedMessage id="platform.footer.href.help.text" />
                  </a>
                </li>
                <li>
                  <a
                    id={id("link-terms", idNamespace)}
                    href={formatMessage({id: "platform.footer.href.termsAndConditions.href"})}
                    target="_blank"
                    rel="noopener noreferrer">
                    <FormattedMessage id="platform.footer.href.termsAndConditions.text" />
                  </a>
                </li>
                <li>
                  <a
                    id={id("link-privacy", idNamespace)}
                    href={formatMessage({id: "platform.footer.href.privacyPolicy.href"})}
                    target="_blank"
                    rel="noopener noreferrer">
                    <FormattedMessage id="platform.footer.href.privacyPolicy.text" />
                  </a>
                </li>
                <li>
                  <a
                    id={id("status-page", idNamespace)}
                    href={formatMessage({id: "platform.footer.href.statusPage.href"})}
                    target="_blank"
                    rel="noopener noreferrer">
                    <FormattedMessage id="platform.footer.href.statusPage.text" />
                  </a>
                </li>
              </List>
            </Col>
            <Col md={12}>
              <Copyright id={id("copy-copyright", idNamespace)}><FormattedMessage id="platform.footer.copy.copyright.text" /></Copyright>
            </Col>
          </Row>
        </Grid>
      </FooterWrapper>
      <Version />
    </>
  )
}

export default injectIntl(Footer)
